import React from "react";

const holder = {
  closeFiltersDropdown(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeFiltersDropdown)
    }
  }
};


export default {
  'ResidentApprovalWrapper.Wrapper.NotApproved': async ({ isOpen, containerRef }, _, internalStateSetter) => {
    if (isOpen) {
      return;
    }

    await internalStateSetter({ isOpen: true });
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;

    document.addEventListener("mousedown", holder.closeFiltersDropdown);
  },

  'ResidentApprovalWrapper.Wrapper.NotApproved.Remind': async ({ isOpen, containerRef }, _, internalStateSetter) => {
    if (isOpen) {
      return;
    }

    await internalStateSetter({ isOpen: true });
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;

    document.addEventListener("mousedown", holder.closeFiltersDropdown);
  },
  'ResidentApprovalWrapper.Wrapper.DropdownWrapper.BorderWrapper.Buttons.Leave': ({ }, _, internalStateSetter) => {
    internalStateSetter('isOpen', false);
  },
  'ResidentApprovalWrapper.Wrapper.DropdownWrapper.BorderWrapper.Buttons.Send': ({ }, outlet, internalStateSetter) => {
    internalStateSetter('isOpen', false);
    outlet({ action: 'send' })
  },
  'ResidentApprovalWrapper.Wrapper.Approved.PopupWrapper.Button': ({ inspection }) => {
    navigator.clipboard.writeText(inspection.approved_event_ip_address);
  }
};
